const colors = require("./colors");

module.exports = {
  background: colors.inkGray[1],
  paper: colors.inkGray[0],
  ui: {
    dark: {
      bold: colors.inkGray[9],
      moderate: colors.inkGray[6],  // 접근성 확보된 보조 텍스트
      subtle: colors.inkGray[4],    // 플레이스홀더, 서브틀한 요소
      light: colors.inkGray[2],     // 매우 연한 배경, 테두리
    },
  },
};
